import {ERROR, PENDING, SUCCESS} from '@travel-frontend/state-handling-sdk';
import {
  ADD_TO_WISHLIST,
  REMOVE_FROM_WISHLIST,
} from '@travel-frontend/ui-components';

import {
  EVENT_ADD_OFFER_TO_CART,
  EVENT_BEST_OFFER_BOXES_LOADED,
  EVENT_FILTER_REMOVE,
  EVENT_FILTER_SET,
  EVENT_PAGE_LOAD,
  EVENT_PAGE_VIEW,
  EVENT_SELECT_HOTEL_ITEM,
  EVENT_SELECT_PROMOTION,
  EVENT_BD4_RECOMMENDED_CLICKED,
  EVENT_BD4_RECOMMENDED_LOADED,
} from '@/redux/middleware/googleTagManager/actionTypes';
import {
  addOfferToCartEvent,
  bestOfferBoxesLoadedEvent,
  filterEvents,
  pageLoadEvent,
  pageViewEvent,
  selectHotelItemEvent,
  selectOfferEvent,
  selectPromotion,
  vacancyCheckEvent,
  bd4RecommendedLoaded,
  bd4RecommendedClicked,
  genericEventHandler,
  removeFromWishlistEvent,
  addToWishlistFailureEvent,
} from '@/redux/middleware/googleTagManager/events';
import {FETCH_AVAILABILITY} from '@/redux/v1/availability/actionTypes';

export const eventsMap = {
  [EVENT_PAGE_LOAD]: pageLoadEvent.handler,
  [EVENT_PAGE_VIEW]: pageViewEvent.handler,
  [EVENT_ADD_OFFER_TO_CART]: addOfferToCartEvent.handler, // possible to use genericEventHandler
  [EVENT_BEST_OFFER_BOXES_LOADED]: bestOfferBoxesLoadedEvent.handler,
  [EVENT_SELECT_HOTEL_ITEM]: selectHotelItemEvent.handler,
  [EVENT_SELECT_PROMOTION]: selectPromotion.handler,
  [EVENT_FILTER_SET]: filterEvents.handler, // possible to use genericEventHandler
  [EVENT_FILTER_REMOVE]: filterEvents.handler, // possible to use genericEventHandler
  [EVENT_BD4_RECOMMENDED_LOADED]: bd4RecommendedLoaded.handler,
  [EVENT_BD4_RECOMMENDED_CLICKED]: bd4RecommendedClicked.handler,
  [PENDING(FETCH_AVAILABILITY)]: selectOfferEvent.handler,
  [SUCCESS(FETCH_AVAILABILITY)]: vacancyCheckEvent.handler,
  [ERROR(FETCH_AVAILABILITY)]: vacancyCheckEvent.handler,
  [SUCCESS(REMOVE_FROM_WISHLIST)]: removeFromWishlistEvent.handler,
  [ERROR(ADD_TO_WISHLIST)]: addToWishlistFailureEvent.handler,
  TRACKING: genericEventHandler,
};
